import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CountIndicatorDirective } from './count-indicator.directive';

@NgModule({
  declarations: [CountIndicatorDirective],
  imports: [CommonModule],
  exports: [CountIndicatorDirective]
})
export class CountIndicatorModule {}

export * from './count-indicator.directive';
